import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../component/modalAddProductCategory.css";

const ModalAddProductCategory = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  productCategoryObject,
}) => {
  const [productCategoryData, setProductCategoryData] = useState(
    productCategoryObject
  );

  const closeModal = () => {
    setProductCategoryData({
      product_category_id: "",
      product_category_name: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-product-category-container">
        <div className="modal-product-category-content">
          <header className="modal-product-category-header">
            <h2 className="modal-product-category-header-title">
              Tambah Kategori Produk
            </h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-product-category-main">
            <div className="form-group">
              <div className="input_title_label_container">
                <span className="input_title_label">Kategori Produk Baru</span>
              </div>
              <div className="input_product_category_field_container">
                <input
                  type="text"
                  value={
                    productCategoryData.product_category_name
                      ? productCategoryData.product_category_name
                      : ""
                  }
                  onChange={(e) =>
                    setProductCategoryData({
                      ...productCategoryData,
                      product_category_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan kategori produk"
                />
              </div>
            </div>
          </main>
          <footer className="modal-product-category-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData =
                  productCategoryData.product_category_id !== "";
                onSubmitData(productCategoryData, isEditData);
                setProductCategoryData({
                  product_category_id: "",
                  product_category_name: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddProductCategory;
